// Display helpers shared by the console tabs.

import moment from 'moment';

export function formatBytes(n) {
  if (!n) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let i = 0;
  let v = n;
  while (v >= 1024 && i < units.length - 1) { v /= 1024; i += 1; }
  return `${v >= 100 || i === 0 ? Math.round(v) : Number(v.toFixed(1))} ${units[i]}`;
}

export function formatDateTime(value, withSeconds = false) {
  return value ? moment(value).format(withSeconds ? 'DD MMM YYYY HH:mm:ss' : 'DD MMM YYYY HH:mm') : '—';
}
